import { EBedroomsCount } from '../../../../json_query';
import { dealTypeFromJsonQuery, FDealType, FOfferType, offerTypeFromJsonQuery } from '../../../../utils/category';
import { ensureSingleTagExists, ensureTagNotExists } from '../helpers';
import { ITagDefinition, TTag } from '../index';

export const IBedroomsMinCountTagType = 'advanced-bedroomsCount';

export interface IBedroomsMinCountTag {
  type: 'advanced-bedroomsCount';
  value: EBedroomsCount;
}

export const isBedroomsMinCountTag = (tag: TTag): tag is IBedroomsMinCountTag => tag.type === IBedroomsMinCountTagType;

export const bedroomsMinCountTagDefinition: ITagDefinition = {
  reduce: (tags, jsonQuery, tagsData, currentLocation, experiments, isFiltersRedesign) => {
    const dealType = dealTypeFromJsonQuery(jsonQuery);
    const offerType = offerTypeFromJsonQuery(jsonQuery);
    const isHidden = dealType === FDealType.RentDaily && offerType === FOfferType.House;

    const value = jsonQuery.bedroom_total ? (jsonQuery.bedroom_total.value.gte as EBedroomsCount) : undefined;

    if (value !== undefined && value !== EBedroomsCount.Any && !isHidden && !isFiltersRedesign) {
      return ensureSingleTagExists(tags, isBedroomsMinCountTag, previousTag => ({
        type: IBedroomsMinCountTagType,
        value,
      }));
    } else {
      return ensureTagNotExists(tags, isBedroomsMinCountTag);
    }
  },
};
